import Vue from "vue";
import CurrencyFilter from "./CurrencyFilter";

export default  {
    currency: Vue.filter("currency", CurrencyFilter)
};
